(function ($) {

  $('.header_tabs .slider-nav').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.header_tabs .slider-for',
    speed: 500,
    cssEase: 'linear',
    focusOnSelect: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          centerMode: true,
        }
      }
    ]
  });
  $('.header_tabs .slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.header_tabs .slider-nav',
    fade: true,
    swipe: false,
    arrows: false
    // prevArrow: '<button><i class="icon-read_more_round_left"></button></i>',
    // nextArrow: '<button><i class="icon-read_more_round"></i></button>',
  });
  /*$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: true,
    centerMode: true,
    focusOnSelect: true
  });*/
}(jQuery));
